import { ReactComponent as CI_DEVTECH } from '@/assets/ci/devtech-gray.svg';
import { ReactComponent as IMG_GITHUB } from '@/assets/images/common/sns-github-gray.svg';
import { ReactComponent as IMG_LINKED_IN } from '@/assets/images/common/sns-linkedin-gray.svg';
import { ReactComponent as IMG_X } from '@/assets/images/common/sns-x-gray.svg';
import { ReactComponent as IMG_YOUTUBE } from '@/assets/images/common/sns-youtube-gray.svg';
import { ReactComponent as OutlinkIcon } from '@/assets/images/icons/icn-outlink.svg';

import Divider from '@/components/atoms/Divider';
import ExternalLink from '@/components/atoms/ExternalLink';
import {
  LINK_GITHUB,
  LINK_LINKED_IN,
  LINK_PARENTAL_GUIDE,
  LINK_PRIVACY_POLICY,
  LINK_TERMS_OF_SERVICE,
  LINK_X,
  LINK_YOUTUBE,
} from '@/constants/links';
import { cn } from '@devsisters/wds-react';
import React from 'react';

type FooterProps = React.ComponentPropsWithoutRef<'footer'>;

type Props = FooterProps;
function Footer(props: Props) {
  const { className, ...footerProps } = props;

  return (
    <footer
      className={cn('flex flex-col items-center bg-text-primary py-12 text-body-14 text-gray-8', className)}
      {...footerProps}
    >
      <div className={'flex w-full max-w-[320px] flex-col gap-4 flex-center lg:max-w-none lg:flex-row lg:gap-7'}>
        <ExternalLink href={LINK_PARENTAL_GUIDE}>
          {'보호자 안내서'}
          <OutlinkIcon width={16} />
        </ExternalLink>
        <Divider className={'bg-gray-6/10 lg:h-7 lg:w-[1px]'} direction={'horizontal'} />
        <ExternalLink className={'font-bold'} href={LINK_PRIVACY_POLICY}>
          {'개인정보처리방침'}
          <OutlinkIcon width={16} />
        </ExternalLink>
        <Divider className={'bg-gray-6/10 lg:h-7 lg:w-[1px]'} direction={'horizontal'} />
        <ExternalLink href={LINK_TERMS_OF_SERVICE}>
          {'이용약관'}
          <OutlinkIcon width={16} />
        </ExternalLink>
      </div>

      <div className={'mt-12 flex flex-center'}>
        <CI_DEVTECH height={20} />
      </div>

      <div className={'mt-11 flex whitespace-pre-line text-center flex-center'}>
        <p>
          {
            '(06019) 서울특별시 강남구 도산대로 327\nTel: 02-2148-0750  Fax: 02-2148-0584\nⓒ 2025 Devsisters Corp. All Rights Reserved.'
          }
        </p>
      </div>

      <div className={'mt-11 flex gap-9 flex-center'}>
        <ExternalLink href={LINK_GITHUB}>
          <IMG_GITHUB width={24} />
        </ExternalLink>
        <ExternalLink href={LINK_YOUTUBE}>
          <IMG_YOUTUBE width={24} />
        </ExternalLink>
        <ExternalLink href={LINK_X}>
          <IMG_X width={24} />
        </ExternalLink>
        <ExternalLink href={LINK_LINKED_IN}>
          <IMG_LINKED_IN width={24} />
        </ExternalLink>
      </div>
    </footer>
  );
}

export default Footer;
